import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import SetupHeader from "./SetupHeader";
import { RccIndicatorCatalogProvider } from "context/RccIndicatorCatalogContext";
import useAuth from "hooks/useAuth";
import { isSuperuserUser } from "utils/dashboardScope";

export default function SetupShell() {
  const { user } = useAuth();

  if (!isSuperuserUser(user)) {
    return <Navigate to="/ghana/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      <RccIndicatorCatalogProvider>
        <SetupHeader />
        <main className="setup-content">
          <Outlet />
        </main>
      </RccIndicatorCatalogProvider>
    </div>
  );
}
